export enum HierarchyLevel {
  Root = 1,
  Child = 2,
  Grandchild = 3,
}
